// Generate a consistent color based on string (name or email)
export const stringToColor = (string) => {
  if (!string) return '#757575'; // Default gray for empty strings
  
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }
  
  return color;
};

// Get user display name for color generation (prioritize name, fallback to email)
export const getUserDisplayName = (user) => {
  if (user.name && user.name.trim()) {
    return user.name.trim();
  }
  if (user.email && user.email.trim()) {
    return user.email.trim();
  }
  return 'Unknown User';
};

// Get user initials for avatar display
export const getUserInitials = (user) => {
  if (user.name && user.name.length > 0) {
    return user.name[0].toUpperCase();
  }
  if (user.email && user.email.length > 0) {
    return user.email[0].toUpperCase();
  }
  return '?'; // fallback
};

// Get avatar props with consistent styling
export const getAvatarProps = (user, size = 36) => {
  const displayName = getUserDisplayName(user);
  return {
    sx: {
      bgcolor: stringToColor(displayName),
      width: size,
      height: size,
      fontSize: size < 30 ? 12 : 14,
    },
    children: getUserInitials(user),
  };
};
